import { render, staticRenderFns } from "./UniformRequestsHistory.vue?vue&type=template&id=0d7eb2ca&scoped=true"
import script from "./UniformRequestsHistory.vue?vue&type=script&lang=js"
export * from "./UniformRequestsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7eb2ca",
  null
  
)

export default component.exports